import React from 'react';
import { useStore } from '../../store/useStore';
import { Input, GalleryUpload, Tabs } from '../ui';
import { Building2, Share2, MapPin, Phone } from 'lucide-react';

export function M1_CompanyData() {
  const { companyData, setCompanyData } = useStore();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCompanyData({ [e.target.name]: e.target.value });
  };

  const tabs = [
    {
      id: 'basic',
      label: 'Dados Básicos',
      icon: <Building2 size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6 space-y-6">
          <GalleryUpload 
            label="Logo da Empresa" 
            description="Faça o upload do logotipo oficial da empresa em alta resolução (PNG ou JPG)." 
            maxFiles={1} 
            onChange={(files) => setCompanyData({ logo: files as any[] })}
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Input label="Razão Social" name="razaoSocial" value={companyData.razaoSocial} onChange={handleChange} placeholder="Empresa LTDA" />
            <Input label="Nome Fantasia" name="nomeFantasia" value={companyData.nomeFantasia} onChange={handleChange} placeholder="Minha Loja" />
            <Input label="CNPJ" name="cnpj" value={companyData.cnpj} onChange={handleChange} placeholder="00.000.000/0001-00" />
            <Input label="Data de Fundação" type="date" name="dataFundacao" value={companyData.dataFundacao} onChange={handleChange} />
          </div>
        </div>
      )
    },
    {
      id: 'digital',
      label: 'Presença Digital',
      icon: <Share2 size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Input label="Site" name="site" value={companyData.site} onChange={handleChange} placeholder="https://www.site.com.br" />
          <Input label="Instagram" name="instagram" value={companyData.instagram} onChange={handleChange} placeholder="@usuario" />
          <Input label="Facebook" name="facebook" value={companyData.facebook} onChange={handleChange} placeholder="Página Facebook" />
          <Input label="LinkedIn" name="linkedin" value={companyData.linkedin} onChange={handleChange} placeholder="Página no LinkedIn" />
          <Input label="TikTok" name="tiktok" value={companyData.tiktok} onChange={handleChange} placeholder="@tiktok" />
          <Input label="YouTube" name="youtube" value={companyData.youtube} onChange={handleChange} placeholder="Canal YouTube" />
        </div>
      )
    },
    {
      id: 'address',
      label: 'Endereço e Instalações',
      icon: <MapPin size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6 space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Input label="CEP" name="cep" value={companyData.cep} onChange={handleChange} placeholder="00000-000" className="lg:col-span-1" />
            <Input label="Rua" name="rua" value={companyData.rua} onChange={handleChange} className="lg:col-span-2" />
            <Input label="Número" name="numero" value={companyData.numero} onChange={handleChange} className="lg:col-span-1" />
            <Input label="Complemento" name="complemento" value={companyData.complemento} onChange={handleChange} className="lg:col-span-2" />
            <Input label="Cidade" name="cidade" value={companyData.cidade} onChange={handleChange} className="lg:col-span-1" />
            <Input label="Estado" name="estado" value={companyData.estado} onChange={handleChange} placeholder="uf" className="lg:col-span-1" />
          </div>
          
          <div className="pt-4 border-t border-gray-100">
            <GalleryUpload 
              label="Fotos do Local (Opcional)" 
              description="A inteligência visual vai analisar fotos da sua loja / fachada / escritório físico para entender o nível da experiência que você entrega." 
              maxFiles={20} 
              onChange={(files) => setCompanyData({ fotosLocal: files as any[] })}
            />
          </div>
        </div>
      )
    },
    {
      id: 'contact',
      label: 'Contatos',
      icon: <Phone size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input label="Telefone Principal" name="telefonePrincipal" value={companyData.telefonePrincipal} onChange={handleChange} placeholder="(00) 0000-0000" />
          <Input label="WhatsApp Principal" name="whatsappPrincipal" value={companyData.whatsappPrincipal} onChange={handleChange} placeholder="(00) 90000-0000" />
          <Input label="E-mail Principal" type="email" name="emailPrincipal" value={companyData.emailPrincipal} onChange={handleChange} placeholder="contato@empresa.com" />
          <Input label="E-mail Financeiro" type="email" name="emailFinanceiro" value={companyData.emailFinanceiro} onChange={handleChange} placeholder="financeiro@empresa.com" />
        </div>
      )
    }
  ];

  return <Tabs tabs={tabs} />;
}
